import { lang } from '@public/utils/filters'
import { DICT as parentDict } from '@public/utils/dict'
import workOrder from './dict/workOrder'
import quality from './dict/quality'
import onlineServicer from './dict/onlineServicer'
import microCallBoard from './dict/microCallBoard'
import flyingRabbit from './dict/flyingRabbit'
import qualityControl from './dict/qualityControl'
import qualityInspection from './dict/qualityInspection'


export const DICT = {
  ...quality,
  ...parentDict,
  ...workOrder, // 工单模块
  ...onlineServicer, // 在线客服
  ...microCallBoard, // 微呼客服接待实况看板
  ...flyingRabbit, // IM
  ...qualityControl,//之间管理
  ...qualityInspection,//质检系统
  // 网点级别
  networkLebel: [
    { value: 22, label: lang('总部'), name: '总部' },
    { value: 334, label: lang('代理区'), name: '代理区' },
    { value: 335, label: lang('中心'), name: '中心' },
    { value: 336, label: lang('网点'), name: '网点' }
  ],
  // 通用是否
  whetherOption: [
    { value: 1, label: lang('是'), name: '是' },
    { value: 2, label: lang('否'), name: '否' }
  ],
  // 网点维度
  NetworkDimension: [
    { value: '1', label: lang('代理区'), name: lang('代理区') },
    { value: '2', label: lang('加盟商'), name: lang('加盟商') },
    { value: '3', label: lang('网点'), name: lang('网点') }
  ],
  // 统计类型
  isRegistration: [
    { value: 1, label: lang('按登记方统计'), name: '按登记方统计' },
    { value: 2, label: lang('按接收方统计'), name: '按接收方统计' }
  ],
  // 网点类型
  networkType: [
    { value: 1, label: lang('网点'), name: '网点' },
    { value: 2, label: lang('集散点'), name: '集散点' },
    { value: 3, label: lang('转运中心'), name: '转运中心' }
  ],
  // 数据形式
  searchType: [
    { value: 1, label: lang('按天计'), name: '按天计' },
    { value: 2, label: lang('按总计'), name: '按总计' }
  ],
  // 通用男女
  sexType: [
    { value: 1, label: lang('男'), name: '男' },
    { value: 2, label: lang('女'), name: '女' }
  ],
  // 工单类型
  W_orkorderTypeTwo: [
    { value: 1, label: lang('普通工单'), name: lang('普通工单') },
    { value: 2, label: lang('理赔工单'), name: lang('理赔工单') },
    { value: 3, label: lang('项目工单'), name: lang('项目工单') },
    { value: 5, label: lang('邮政工单'), name: lang('邮政工单') }
  ],
  // 工单状态
  W_orkorderStatus: [
    { value: 0, label: lang('待分配'), name: lang('待分配') },
    { value: 1, label: lang('待处理'), name: lang('待处理') },
    { value: 2, label: lang('处理中'), name: lang('处理中') },
    { value: 3, label: lang('已关闭'), name: lang('已关闭') },
    { value: 4, label: lang('待审核'), name: lang('待审核') },
    { value: 5, label: lang('已答复'), name: lang('已答复') },
    { value: 6, label: lang('已拒绝'), name: lang('已拒绝') }
  ]
}
